import { Box, Typography, useTheme, useMediaQuery, Button } from "@mui/material";
import desktopBg from "../../assets/home-owner/images/designer-files-d.jpg";
import mobileBg from "../../assets/home-owner/images/designer-files-m.jpg";
import { ArrowRightIcon } from "@mui/x-date-pickers/icons";
import { Link } from "react-router";
import { Pages } from "../../utils";

export const PrettySpacesSection = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const bgImage = isMobile ? mobileBg : desktopBg;

    return (
        <Box
            sx={{
                width: "100%",
                minHeight: { xs: 925, md: 952 },
                backgroundImage: `url(${bgImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                display: "flex",
                justifyContent: "center",
                py: { xs: 8, md: 13.5 },
            }}
            className="pretty-spaces-section"
        >
            <Box
                sx={{
                    width: "100%",
                    maxWidth: 1216,
                    mx: "auto",
                    px: { xs: 2, md: 4 },
                    textAlign: "center",
                }}
                className="pretty-spaces-container"
            >
                <Typography
                    variant="overline"
                    className="text-center "
                    mb="16px"
                    sx={{
                        color: "#CFBCFF",
                    }}
                >
                    DESIGNER FILES
                </Typography>
                <Typography
                    variant={"display2" as any}
                    component="h2"
                    className="text-center text-white"
                    mb={{ xs: "32px", md: "28px" }}
                >
                    BUT YES, WE ALSO HAVE PRETTY SPACES
                </Typography>
                <div className="expand-table-container">
                    <Button
                        variant="outlined"
                        className="expand-table thin small-radius"
                        size="large"
                        color={"white" as any}
                        endIcon={<ArrowRightIcon />}
                        component={Link}
                        to={Pages.DESIGNER_FILES_PUBLIC}
                        sx={{
                            py:{md:2},
                            px:{md:3},
                        }}
                    >
                        <Typography variant="body2" fontWeight={600} component="span">
                            Browse Designer Files
                        </Typography>
                    </Button>
                </div>
            </Box>
        </Box>
    );
}; 
